function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PitcairnIslandsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1840",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1840)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1840",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1840)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.4621 11.7518C15.4621 11.7518 15.5361 12.5318 15.3738 12.9737C15.2114 13.4157 15.1289 13.6722 15.1289 13.3897C15.1289 13.1072 15.0149 12.8834 14.9232 12.8834C14.8314 12.8834 14.9038 13.1635 14.8117 13.1635C14.7195 13.1635 14.402 13.2117 14.402 13.0475C14.402 12.8834 14.3602 13.4879 14.5662 13.542C14.7723 13.596 14.4662 13.7638 14.3296 13.7118C14.3296 13.7118 14.8916 13.8854 15.1121 14.0333C15.1121 14.0333 15.7728 14.8169 16.3909 14.7213C16.3909 14.7213 15.5493 14.4453 15.6976 13.918C15.8459 13.3907 16.3909 13.3145 16.3909 13.3145C16.3909 13.3145 16.6466 13.3957 16.6389 13.6086C16.6313 13.8214 16.8259 13.542 16.8259 13.542C16.8259 13.542 16.8573 13.273 16.8227 13.2074C16.7882 13.1418 17.4085 13.0147 17.4477 12.7378C17.4477 12.7378 16.8138 12.7653 16.7703 12.6942C16.7268 12.6231 16.9665 12.5115 16.8915 12.3728C16.8165 12.2342 15.6976 13.1635 15.6976 13.1635C15.6976 13.1635 16.084 12.531 16.084 12.1913C16.084 11.8516 15.9858 11.6195 15.6976 11.6195C15.4093 11.6195 15.4621 11.7518 15.4621 11.7518Z",
        fill: "#5EAA22"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.2863 11.9393C21.2858 11.9401 21.2868 11.9409 21.2874 11.9403C21.3219 11.9076 21.584 11.6719 21.803 11.8525C22.0379 12.0462 21.6846 12.235 21.6846 12.235C21.6846 12.235 21.8498 12.3872 22.0386 12.3872C22.2275 12.3872 22.2738 12.235 22.2738 12.235C22.2738 12.235 22.2882 12.5736 22.9041 12.7019C22.9041 12.7019 23.1239 12.4021 22.9041 12.238C22.9041 12.238 23.1638 12.1868 23.1449 11.9871C23.1449 11.9871 22.9315 12.0562 22.7793 11.8974C22.6271 11.7387 22.3305 11.6655 22.1148 11.7021C21.5596 11.5119 21.314 11.8926 21.2863 11.9393Z",
        fill: "#5EAA22"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5528 13.6457C17.5528 13.6457 18.1897 14.7838 17.7916 15.0197C17.3935 15.2555 19.6844 15.0877 19.9003 15.0197C20.1161 14.9516 19.8567 14.5928 19.6173 14.4931C19.3779 14.3935 18.3938 14.0621 18.132 13.8121C17.8702 13.5621 18.0301 13.4734 18.2409 13.2266C18.4518 12.9799 19.2324 12.8812 19.2324 12.6506C19.2324 12.4199 19.7275 11.4687 20.0736 11.3969C20.4197 11.3252 20.2327 11.2121 20.1532 11.2121C20.0736 11.2121 19.5951 11.6806 19.4138 11.5961C19.2324 11.5116 19.2102 11.5175 19.4138 11.3132C19.6173 11.1089 19.7705 10.8738 19.5015 11.0429C19.2324 11.2121 18.7888 11.4799 18.5755 11.4799C18.3623 11.4799 17.6031 11.3886 17.6973 11.5961C17.7916 11.8036 17.8315 12.1638 18.2409 12.4072C18.6503 12.6506 18.4724 12.8286 18.132 13.0631C17.7916 13.2976 17.5528 13.6457 17.5528 13.6457Z",
        fill: "#96877D"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.779 12.1406L20.5654 14.4529C20.5654 14.4529 20.53 15.1061 21.3976 14.6709C22.2653 14.2356 22.2311 13.9269 22.4813 13.9269C22.7314 13.9269 22.8109 13.795 22.8109 13.795L22.6442 13.6705C22.6442 13.6705 22.625 13.4434 22.7305 13.3924C22.7305 13.3924 22.5235 13.2841 22.4939 13.3746C22.4643 13.465 22.3183 13.1853 22.4009 13.1853C22.4009 13.1853 22.2183 13.4661 22.1798 13.5757C22.1798 13.5757 21.9156 13.4737 21.9283 13.0009C21.9409 12.5281 21.779 12.1406 21.779 12.1406Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.0023 11.7745C16.0023 11.7745 15.3843 11.9112 15.4509 12.0534C15.5176 12.1956 15.6158 12.0495 15.3132 12.221C15.3132 12.221 14.7817 12.6114 14.6658 12.5691C14.55 12.5268 14.7479 12.6674 14.7479 12.221C14.7479 11.7745 14.4392 12.1379 14.7479 11.8399C15.0565 11.5418 15.1648 11.7745 15.3132 11.603C15.4616 11.4315 15.3282 11.5227 15.7309 11.5227C16.1335 11.5227 16.0023 11.7745 16.0023 11.7745Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.888 14.0725C17.888 14.0725 16.1577 15.3643 15.8118 15.4607C15.466 15.5572 16.5231 15.4342 16.7814 15.2637C17.0396 15.0931 17.888 14.0725 17.888 14.0725Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.3184 16.3387C21.3184 16.3387 21.4845 17.3565 21.0509 17.2563C20.6174 17.1561 20.4374 17.1043 20.4374 17.1043C20.4374 17.1043 20.5965 17.5784 20.8237 17.5784C20.8237 17.5784 21.2109 18.2952 21.0619 18.5215C21.0619 18.5215 21.7288 18.0075 21.621 17.5988C21.5132 17.1901 21.7934 17.6661 21.7934 17.6661C21.7934 17.6661 22.0388 17.7786 22.2162 17.6529C22.3936 17.5272 22.214 17.5831 22.0366 17.3437C21.8591 17.1043 21.9029 16.432 21.3633 16.0836C20.8237 15.7352 20.6981 15.7463 20.6981 15.7463C20.6981 15.7463 20.3007 15.1291 20.5388 15.1699C20.5388 15.1699 22.2451 15.7256 22.2895 15.868C22.3338 16.0104 22.7863 15.9843 22.5601 15.5771C22.3338 15.1699 21.1141 14.9245 20.9689 14.8096C20.8237 14.6948 20.9588 14.2592 20.6981 14.1643C20.4374 14.0694 19.7252 13.3961 19.7257 13.0716C19.7261 12.7471 19.3909 12.5944 19.0995 12.5944C18.8082 12.5944 18.2595 12.5144 18.0277 12.5144C17.7959 12.5144 17.5798 12.8828 17.8038 12.8828C18.0277 12.8828 17.8364 13.5725 17.4614 13.7232C17.0865 13.8739 16.7966 14.0906 16.3684 14.0906C15.9403 14.0906 16.9745 14.4413 17.1394 14.3028C17.3043 14.1643 17.2502 13.9579 17.8038 13.7232C18.3574 13.4885 18.8857 13.3495 18.8188 13.5364C18.7519 13.7232 18.9226 14.0357 19.1834 13.9226C19.4442 13.8095 19.5279 13.5238 19.5279 13.7232C19.5279 13.9226 19.9277 14.9469 20.2333 15.3466C20.5388 15.7463 21.3184 16.3387 21.3184 16.3387Z",
        fill: "#5EAA22"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.6783 12.5987C17.6783 12.5987 17.4755 12.9058 17.6783 12.9058C17.8812 12.9058 18.2075 12.9058 18.0087 12.7522C17.8099 12.5987 17.6783 12.5987 17.6783 12.5987Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        d: "M18.3562 12.5913C18.3562 12.5913 18.3572 12.7955 18.4978 12.7955C18.6384 12.7955 18.7635 12.9997 18.7635 12.7955C18.7635 12.5913 18.9589 12.659 18.6576 12.5913C18.3562 12.5236 18.3562 12.5913 18.3562 12.5913Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.2222 12.6381C19.2222 12.6381 19.0867 12.735 19.1544 12.908C19.2222 13.0809 19.3755 13.4231 19.1544 13.4231C18.9334 13.4231 18.7515 13.5465 18.9242 13.5465C19.0969 13.5465 19.4041 13.6699 19.4041 13.5465C19.4041 13.4231 19.5291 13.75 19.5291 13.5465C19.5291 13.3431 19.5291 13.2458 19.5291 13.1265C19.5291 13.0072 19.6541 12.9729 19.5291 12.8055C19.4041 12.6381 19.2222 12.6381 19.2222 12.6381Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.5354 13.8286C19.5354 13.8286 19.8179 14.6733 19.9715 14.7822C20.1251 14.891 20.194 15.8083 20.2614 15.908C20.3288 16.0078 21.2474 16.5111 21.2474 16.7813C21.2474 17.0514 21.5303 16.5737 21.3889 16.3062C21.2474 16.0387 20.8022 15.4692 20.4819 15.345C20.1617 15.2208 20.2023 14.9201 20.135 14.7087C20.0677 14.4973 20.5334 14.8795 20.135 14.4001C19.7365 13.9206 19.7471 14.1779 19.8593 14.1779C19.9715 14.1779 20.0837 14.1213 19.9715 14.0468C19.8593 13.9723 19.5354 13.8286 19.5354 13.8286Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.5406 15.5705C16.5406 15.5705 15.623 17.1099 15.4593 17.1895C15.2955 17.269 15.1735 17.2852 15.0898 17.1895C15.0061 17.0938 14.9975 17.4463 15.0898 17.5428C15.1821 17.6393 15.4593 17.6393 15.6131 17.4679C15.6131 17.4679 15.6374 17.901 15.8771 18.2275C16.1167 18.554 16.2165 18.4639 16.2165 18.6485C16.2165 18.8331 16.2732 19.0776 16.3463 19.0776C16.4195 19.0776 16.4761 19.6588 16.3463 19.6588C16.2165 19.6588 16.6471 19.7065 16.8347 19.5611C17.0224 19.4157 17.1026 19.305 17.0625 19.305C17.0224 19.305 16.5406 19.0641 16.5406 18.8936C16.5406 18.7231 16.2165 18.5896 16.2165 18.3365C16.2165 18.0834 16.0482 17.7825 16.0482 17.6626C16.0482 17.5428 16.1921 17.7089 16.3463 17.5954C16.5005 17.4819 16.5406 17.1895 16.5406 17.1895C16.5406 17.1895 16.2977 17.3442 16.2165 17.2668C16.1354 17.1895 15.8799 17.0367 16.0482 16.7746C16.2165 16.5126 16.5406 15.5705 16.5406 15.5705Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.1307 10.7153C18.1307 10.7153 17.8021 10.8542 17.9116 11.0604C18.0212 11.2667 18.0605 11.358 18.1307 11.3124C18.2008 11.2667 18.6931 11.1804 18.5828 10.9478C18.4725 10.7153 18.2415 10.7153 18.2415 10.7153H18.1307Z",
        fill: "#5EAA22"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.2704 10.6038C19.2704 10.6038 18.8365 10.4214 18.9811 10.6038C19.1258 10.7862 19.3109 10.8824 19.444 10.8824C19.5771 10.8824 19.8538 10.8447 19.7154 10.7711C19.5771 10.6975 19.2704 10.6038 19.2704 10.6038Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.9885 15.3334C14.9901 15.3259 14.9813 15.3205 14.9755 15.3256C14.8969 15.395 14.6 15.68 14.7195 15.9267C14.8568 16.2099 14.994 16.3083 14.994 16.3083C14.994 16.3083 15.0776 16.7419 15.2503 16.8599C15.2503 16.8599 15.4823 16.8486 15.4938 16.5111C15.4938 16.5111 15.8878 16.4013 16.0036 16.635C16.0036 16.635 15.9272 16.6613 15.9272 16.8599C15.9272 17.0585 16.1055 17.2736 16.1055 17.2736C16.1055 17.2736 16.1871 16.5887 16.554 16.147C16.9209 15.7054 17.0259 15.6183 17.0259 15.6183V15.1213C17.0259 15.1213 16.2668 15.7089 16.1055 16.1975C16.1055 16.1975 15.7232 16.2096 15.5679 16.147C15.4126 16.0845 15.7619 15.9819 15.5679 15.7595C15.3739 15.5372 15.4629 16.0726 15.2503 15.9267C14.9056 15.8356 14.9669 15.4354 14.9885 15.3334Z",
        fill: "#5EAA22"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.6401 14.9138L20.5286 14.9138V17.1707C20.5286 17.1707 20.2116 19.0149 18.5182 19.9234C18.5182 19.9234 16.8779 19.0023 16.6401 17.1707V14.9138Z",
        fill: "#5EAA22"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_1840",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "16",
        y: "14",
        width: "5",
        height: "6",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.6401 14.9138L20.5286 14.9138V17.1707C20.5286 17.1707 20.2116 19.0149 18.5182 19.9234C18.5182 19.9234 16.8779 19.0023 16.6401 17.1707V14.9138Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_1840)",
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.4887 14.7918L16.7899 18.1411L19.0938 16.1534L20.6795 18.6502V14.7918L19.0938 16.0267L18.4887 14.7918Z",
          fill: "#58A5FF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M18.4352 17.2136C18.4352 17.1436 18.4919 17.0868 18.5619 17.0868V17.0868C18.6319 17.0868 18.6887 17.1436 18.6887 17.2136V19.3515C18.6887 19.4215 18.6319 19.4782 18.5619 19.4782V19.4782C18.4919 19.4782 18.4352 19.4215 18.4352 19.3515L18.4352 17.2136Z",
          fill: "#FFD018"
        }), /*#__PURE__*/_jsx("path", {
          d: "M17.9882 17.7375C17.9228 17.7375 17.8698 17.6845 17.8698 17.6192V17.6192C17.8698 17.5538 17.9228 17.5009 17.9882 17.5009H19.146C19.2114 17.5009 19.2643 17.5538 19.2643 17.6192V17.6192C19.2643 17.6845 19.2114 17.7375 19.146 17.7375H17.9882Z",
          fill: "#FFD018"
        }), /*#__PURE__*/_jsx("path", {
          d: "M18.7976 19.1927L18.6686 19.2982C18.4785 19.0657 18.3051 18.9539 18.1519 18.9539C17.9263 18.9539 17.7428 18.7645 17.5932 18.4051L17.7471 18.341C17.8736 18.645 18.0113 18.7873 18.1519 18.7873C18.3649 18.7873 18.579 18.9254 18.7976 19.1927Z",
          fill: "#FFD018"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.4428 17.8319C17.4423 17.8314 17.4415 17.8318 17.4415 17.8325V18.6457C17.4415 18.6462 17.4421 18.6466 17.4426 18.6464L18.0501 18.3946C18.0507 18.3944 18.0508 18.3937 18.0504 18.3933L17.4428 17.8319Z",
          fill: "#FFD018"
        }), /*#__PURE__*/_jsx("path", {
          d: "M18.3813 19.1927L18.5103 19.2982C18.7004 19.0657 18.8738 18.9539 19.027 18.9539C19.2526 18.9539 19.4361 18.7645 19.5857 18.4051L19.4318 18.341C19.3053 18.645 19.1675 18.7873 19.027 18.7873C18.814 18.7873 18.5999 18.9254 18.3813 19.1927Z",
          fill: "#FFD018"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.7361 17.8319C19.7366 17.8314 19.7374 17.8318 19.7374 17.8325V18.6457C19.7374 18.6462 19.7368 18.6466 19.7363 18.6464L19.1288 18.3946C19.1282 18.3944 19.1281 18.3937 19.1285 18.3933L19.7361 17.8319Z",
          fill: "#FFD018"
        }), /*#__PURE__*/_jsx("rect", {
          x: "18.3063",
          y: "16.2418",
          width: "0.507042",
          height: "0.717722",
          fill: "white"
        })]
      })]
    })]
  }), /*#__PURE__*/_jsx("mask", {
    id: "mask3_621_1840",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "14",
    height: "11",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "13.5",
      height: "10.5",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask3_621_1840)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M-1.50319 12.7499L1.46752 14.0528L13.5674 4.41659L15.1344 2.48044L11.9577 2.04497L7.0224 6.19749L3.05002 8.99532L-1.50319 12.7499Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M-1.09645 13.6627L0.41699 14.4188L14.5718 2.30054H12.4467L-1.09645 13.6627Z",
      fill: "#F50100"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.0032 12.7499L12.0325 14.0528L-0.0674057 4.41659L-1.63439 2.48044L1.54236 2.04497L6.47762 6.19749L10.45 8.99532L15.0032 12.7499Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.9019 13.4049L13.3884 14.161L7.3612 8.97254L5.57425 8.39285L-1.78512 2.48695H0.339926L7.69516 8.25267L9.64888 8.94778L14.9019 13.4049Z",
      fill: "#F50100"
    }), /*#__PURE__*/_jsxs("mask", {
      id: "path-34-outside-1_621_1840",
      maskUnits: "userSpaceOnUse",
      x: "-1",
      y: "2",
      width: "16",
      height: "13",
      fill: "black",
      children: [/*#__PURE__*/_jsx("rect", {
        fill: "white",
        x: "-1",
        y: "2",
        width: "16",
        height: "13"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z"
      })]
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z",
      fill: "#F50100"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.98838 3V2.25H5.23838V3H5.98838ZM7.48838 3H8.23838V2.25H7.48838V3ZM5.98838 7.5V8.25H6.73838V7.5H5.98838ZM0 7.5V6.75H-0.75V7.5H0ZM0 9H-0.75V9.75H0V9ZM5.98838 9H6.73838V8.25H5.98838V9ZM5.98838 13.5H5.23838V14.25H5.98838V13.5ZM7.48838 13.5V14.25H8.23838V13.5H7.48838ZM7.48838 9V8.25H6.73838V9H7.48838ZM13.5 9V9.75H14.25V9H13.5ZM13.5 7.5H14.25V6.75H13.5V7.5ZM7.48838 7.5H6.73838V8.25H7.48838V7.5ZM5.98838 3.75H7.48838V2.25H5.98838V3.75ZM6.73838 7.5V3H5.23838V7.5H6.73838ZM0 8.25H5.98838V6.75H0V8.25ZM0.75 9V7.5H-0.75V9H0.75ZM5.98838 8.25H0V9.75H5.98838V8.25ZM6.73838 13.5V9H5.23838V13.5H6.73838ZM7.48838 12.75H5.98838V14.25H7.48838V12.75ZM6.73838 9V13.5H8.23838V9H6.73838ZM13.5 8.25H7.48838V9.75H13.5V8.25ZM12.75 7.5V9H14.25V7.5H12.75ZM7.48838 8.25H13.5V6.75H7.48838V8.25ZM6.73838 3V7.5H8.23838V3H6.73838Z",
      fill: "#F7FCFF",
      mask: "url(#path-34-outside-1_621_1840)"
    })]
  })]
}));
//# sourceMappingURL=PitcairnIslands.js.map